<div id="confirmDialog" [class]="data.type">
    <h3 mat-dialog-title class="header-type-3">
        <span><fa-icon [icon]="icon" /></span> {{ data.title }}
    </h3>
    <mat-dialog-content>
        <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-stroked-button (click)="onCancel()">{{ cancelText }}</button>
        <button class="confirm-btn" mat-flat-button (click)="onConfirm()">{{ confirmText }}</button>
    </mat-dialog-actions>
</div>
